(() => {
  if (window.deadstockProductGridLoading) return;
  window.deadstockProductGridLoading = true;

  const componentSelector = 'collection-component[data-product-grid-loading]';

  const waitForFeaturedProduct = () =>
    new Promise((resolve) => {
      if (!document.documentElement.classList.contains('campaign-featured-pending')) {
        resolve();
        return;
      }

      const observer = new MutationObserver(() => {
        if (document.documentElement.classList.contains('campaign-featured-pending')) return;
        observer.disconnect();
        resolve();
      });
      observer.observe(document.documentElement, { attributes: true, attributeFilter: ['class'] });
      window.setTimeout(() => {
        observer.disconnect();
        resolve();
      }, 10500);
    });

  const waitForLeadImages = async (grid) => {
    const images = [...grid.querySelectorAll('.card__media img')].slice(0, 4);
    if (!images.length) return;

    const decoded = Promise.all(
      images.map((image) => {
        if (image.complete) return Promise.resolve();
        if (typeof image.decode === 'function') return image.decode().catch(() => {});
        return new Promise((resolve) => {
          image.addEventListener('load', resolve, { once: true });
          image.addEventListener('error', resolve, { once: true });
        });
      }),
    );
    await Promise.race([decoded, new Promise((resolve) => window.setTimeout(resolve, 1500))]);
  };

  const animateGrid = (component, grid) => {
    component
      .querySelector('#ProductGridContainer')
      ?.classList.remove('scroll-trigger', 'animate--slide-in', 'scroll-trigger--offscreen');
    [...grid.children].forEach((product, index) => {
      product.classList.remove('scroll-trigger', 'animate--slide-in', 'scroll-trigger--offscreen');
      product.classList.add('standard-product-grid__product--enter');
      product.style.setProperty('--animation-order', index);
    });
  };

  const initialize = async (component) => {
    if (component.dataset.productGridLoadingInitialized === 'true') return;
    component.dataset.productGridLoadingInitialized = 'true';

    await waitForFeaturedProduct();
    let grid = component.querySelector('ul#product-grid');
    if (!grid) {
      component.classList.add('product-grid-is-ready');
      return;
    }

    await waitForLeadImages(grid);
    if (!component.isConnected) return;
    animateGrid(component, grid);
    requestAnimationFrame(() => component.classList.add('product-grid-is-ready'));

    const container = component.querySelector('#ProductGridContainer');
    if (!container) return;
    new MutationObserver(() => {
      const currentGrid = component.querySelector('ul#product-grid');
      if (!currentGrid || currentGrid === grid) return;
      grid = currentGrid;
      animateGrid(component, grid);
    }).observe(container, { childList: true, subtree: true });
  };

  const initializeAll = (root = document) => {
    if (root.matches?.(componentSelector)) initialize(root);
    root.querySelectorAll?.(componentSelector).forEach(initialize);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initializeAll(), { once: true });
  } else {
    initializeAll();
  }
  document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));
})();
